import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Text from '@dbk/ui-text';
import { NotificationWarning, Refresh } from '@dbk/ui-icons';
import { createContainer } from '@dbk-legacy/muster/react';
import {  H1 } from '@dbk/ui-text';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import ReportPortfolioSelector from '../../../components/app/report-portfolio';
import ReportCategoryParent from '../report-category-parent'
import ReportCategoryDetailsParent from '../report-category-details-parent';
import ReportCustomDetails from '../report-custom-details';
import { ReportTypes, EDELIVERY, CUSTOM_REPORT_TYPES, SELECTED_RANGE, FILTER_CATEGORY, PALETTE, KEY_CODE } from '../constants';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import styles from './report-home.style';
import Button from '@dbk/ui-buttons';
import isEnterorSpaceKeyPressed from '../../../../../../src/utils/isEnterorSpaceKeyPressed';

class ReportHome extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      parentViewTab: 0,
      detailViewTab: 0,
      reportType: ReportTypes.STATEMENTS,
      hideWarning: false,
    };
    props.resetStatmentsVariables();
   // const { hideDWOPortfolioSelector } = this.props; //No need to hide portfolio-selector for reports,WMCE-4443 using common selector
  //  hideDWOPortfolioSelector(true);
  }

  /**
   * function: componentWillMount will be used to load the documents
   */
  componentWillMount() {
    // this.fetchList();
  }

  // function: to fetch the list
  fetchList = () => {
    // Fetch Report Type ( CustomReports / Statements(edocuments),
    const { reports: { selectedReportType } } = this.props;
    if (selectedReportType === ReportTypes.STATEMENTS) {
      // Reset all variables and then fetch list accordingly
      // Default values:: Category-Unread, range- 7days,
      this.props.getDocuments();
    }
    // TODO: Custom reports code goes here

  }

  /**
   * function: will verify if data is fetched or not
   */
  componentDidUpdate(prevProps, prevState) {
    // TODO : Check reporttype
    const {
      reports:
      {
        statement: { defaultUnreadList, defaultList },
        selectedReportDetailsDateRange,
        selectedReportType
      }
    } = this.props;
    if (selectedReportType === ReportTypes.STATEMENTS) {
      if ((prevProps.reports.statement.defaultUnreadList !== defaultUnreadList ||
        prevProps.reports.statement.defaultList !== defaultList) ||
        (prevProps.reports.selectedReportDetailsDateRange !==
          selectedReportDetailsDateRange)) {

        // this.filterStatementsData();
      }
    }
    if(document.querySelector('.error-title')){
      document.querySelector('.error-title').focus();
    }
  }

  componentWillUnmount() {
    const { setInitialReportsCall, hideDWOPortfolioSelector } = this.props;
   // hideDWOPortfolioSelector(false);
    setInitialReportsCall(true);
    this.props.setSelectedReportType(ReportTypes.STATEMENTS);
    this.props.reports.custom.setSelectedCustomReportType(CUSTOM_REPORT_TYPES.TRANSACTION_HISTORY);
    this.props.reports.setSelectedCategoryTabIndex(SELECTED_RANGE.LAST_WEEK);
    this.props.reports.setDropdownDateRangeText(this.props.i18n.messages["app.trade.filter.selectDate"]);
    this.props.reports.setDropdownRangeSelected(SELECTED_RANGE.LAST_90_DAYS);
    this.props.reports.setDropdownPrevRangeSelected(SELECTED_RANGE.LAST_90_DAYS);
    this.props.reports.statement.setCategoryOrder([]);
    this.props.reports.setFilterCategory(FILTER_CATEGORY.ALL)
  }
  filterStatementsData = () => {
    this.props.setSelectedRangeList();
  }

  componentDidMount() {
    const { reports: { initialReportsCall, startDate,endDate }, setInitialReportsCall, resetStatmentsVariables, setStartDate, setEndDate } = this.props;
    if (initialReportsCall === true) {
      resetStatmentsVariables();
      this.fetchList();
      setInitialReportsCall(false);
    }
    if(startDate && endDate){
      setStartDate(null);
      setEndDate(null);
    }
    if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }
  }


  componentWillReceiveProps(nextProps){
    const {
      getDocuments,
      app: {user: {selectedPortfolioData}},
      reports: {startDate, endDate }
  } = this.props;
  if(selectedPortfolioData.id !== nextProps.app.user.selectedPortfolioData.id 
      || selectedPortfolioData.relId !== nextProps.app.user.selectedPortfolioData.relId ){
        if (startDate && endDate) {
          this.props.fetchDocumentsForCategories(startDate, endDate);
        }
  
        // } else {
        getDocuments();
  }
  }

  /**
  * function: handleReportTypeSelection will update the state with selected report type
  */
  handleReportTypeSelection = (index) => {
    const { reports: {
      startDate,
      endDate
    }, setStartDate, setEndDate } = this.props;
    if(startDate && endDate){
      setStartDate(null);
      setEndDate(null);
    }
    this.props.setSelectedReportType(index);
  }



  /**
  * function: closeBlurModel will update the state and hide the BlurModel
  */
  closeBlurModel = async() => {
    this.setState({ hideWarning: true });
    await this.props.setBlurModalError(null);
    if (this.props.reports.errorResponse) { //WMCE-59802-when reports ms is down, on closing of error model redirecting to dashboard
      this.props.changePage('/dashboard')
      await this.props.setErrorResponse(false);
    }
  };

  onPageRefresh = (e) => {
    const { getDocuments } = this.props;
    if(isEnterorSpaceKeyPressed(e)){
      getDocuments()  
    }

  }

  renderErrorModal = () => {
    const { reports: { blurModalError } } = this.props;
    return (
      <div className="row">
        <div className="small-12 text-center">
          <div className="center">
            <NotificationWarning color='#b92635' secondaryColor='#152139' width={50} height={50} />
              <div className="pad-top-25 pad-bottom-25 center">
                <div className="error-title" tabIndex={0}>
                  <Text numberOfLines={1}>{blurModalError}</Text>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }

  render() {
    const { i18n: { messages }, app: { config: { showOrderReport } },
      reports: { selectedReportType, blurModalError , showSpinner}, auth: { isRMUserGroup } } = this.props;
    if (blurModalError !== null) {
      return (
        <BlurModal
          visible={blurModalError !== null}
          doneVisible={false}
          title={messages['app.chedelivery.reports.systemErrorTitle']}
          onDone={() => this.closeBlurModel()}
          className={"model-window-login"}
        >
          {this.renderErrorModal()}
        </BlurModal>
      );
    }

    else if(showSpinner)
    return (
      <div>
        <LoadingCircle />
      </div>
    )

    return <div>
      {/* <div>
        <ReportPortfolioSelector />  // WMCE- 6458, Using common selection widget in all tabs. 
      </div> */}
      <div className="row large-collapse">
        <div className="profile-container">
          <div id="title_report_reportHome_test" className="profile-container__title reportHome reportHome__parent" style={{paddingLeft:30}}>
            <div className='reports-header'>
              <H1 tabIndex={0}>{messages['app.common.pageTitle.reports']}</H1>
              <div tabIndex={0} className="reportsRefreshIconParent" onKeyDown={this.onPageRefresh} onClick={this.onPageRefresh} aria-label={messages['app.reports.reportRefreshButton']}>
                <Refresh className="reportsRefreshIcon" id="refresh" width={30} height={30} color={PALETTE.primaryText} />
              </div>

            </div>
            { showOrderReport && <div className='order-report' style={isRMUserGroup? {marginTop:40} : {}}>
              <Button
                size='large'
                tabIndex={0}
                fullWidth={false}
                onClick={() => this.props.changePage('/reports/adhoc-statement')}
                disabled={isRMUserGroup}>
                  {messages['app.reports.orderReport.orderReportButton']}
              </Button>

            </div> }

            {/* <button onClick={() => this.props.changePage('/reports/adhocStatement')} >goto</button> */}
          </div>
          <ScrollableLayout testID="reports-screen" style={{padding:0}}
            body={
              <React.Fragment>
              <div className="row scrollBarHide" id="scrollBarHide" >
                <div className="columns large-12" >
                  {
                    <ReportCategoryParent onReportTypeClicked={this.handleReportTypeSelection} />
                  }
                </div>
              </div>
              <div className='row'>
                <div className="columns large-12" >
                      <ReportCategoryDetailsParent selectedReportType={selectedReportType} />
                </div>
              </div>
              </React.Fragment>
            }
          />
        </div>
      </div>
    </div>

  }
}


ReportHome.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  reports: PropTypes.object,
  hideWarning: PropTypes.bool
};

ReportHome.defaultProps = {
  i18n: {},
  reports: {},
  hideWarning: 0
};

export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    edelivery: {
      getUserPreferences: { $call: 'getUserPreferences' },
      showPrompt: true,
    },
    app: {
      user: {
        selectedPortfolioData: true
      },
      config: {
        showOrderReport: true
      }
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getDocuments: {
      $call: 'reports.getDocuments',
    },
    setReportDetailDateRange: {
      $call: 'reports.setReportDetailDateRange',
    },
    setSelectedRangeList: {
      $call: 'reports.setSelectedRangeList',
    },
    setSelectedReportType: {
      $call: 'reports.setSelectedReportType'
    },
    getLastStatements: {
      $call: 'reports.getLastStatements',
    },
    setSelectedCategoryId: {
      $call: 'reports.setSelectedCategoryId'
    },
    setBlurModalError: {
      $call: 'reports.setBlurModalError'
    },
    setErrorResponse: {
      $call: 'reports.setErrorResponse'
    },
    resetStatmentsVariables: {
      $call: 'reports.resetStatmentsVariables'
    },
    reports: {
      lastMonthStatements: true,
      blurModalError: true,
      errorResponse: true,
      showSpinner: true,
      statement: {
        defaultList: true,
        defaultUnreadList: true,
        setCategoryOrder: { $set: 'categoryOrder'}
      },
      filterCategory: true,
      setFilterCategory:{
        $set: 'filterCategory'
      },
      selectedCategoryId: true,
      selectedReportDetailsDateRange: true,
      selectedReportType: true,
      initialReportsCall: true,
      startDate: true,
      endDate: true,
      user: {
        setSelectedPortfolioId: {
          $set: 'selectedPortfolioId',
        },
      },
      custom : {
        setSelectedCustomReportType: {
          $set: 'selectedCustomReportType'}
      },
      setSelectedCategoryTabIndex: {
        $set: 'selectedCategoryTabIndex'
      },
      setDropdownDateRangeText: {
        $set: 'dropdownDateRangeText'
      },
      setDropdownRangeSelected: {
        $set: 'dropdownRangeSelected'
      },
      setDropdownPrevRangeSelected: {
        $set: 'dropdownPrevRangeSelected'
      }
    },
    fetchDocumentsForCategories: {
      $call: 'reports.fetchDocumentsForCategories'
    },
    setStartDate: { $set: 'reports.startDate' },
    setEndDate: { $set: 'reports.endDate' },
    hideDWOPortfolioSelector:{
      $set: 'reports.hideDWOPortfolioSelector'
    },
    getStatementPdf: {
      $call: 'monthly.getPdf',
    },
    dailyPdf: {
      pdf: true,
      setEmpty: { $set: 'pdf' },
    },
    resetAdvicesDates: { $call: 'advices.resetDates' },
    resetReportsDates: { $call: 'reports.resetDates' },
    portfolio: {
      netIncome: {
        value: true,
      },
    },
    setInitialReportsCall: {
      $set: 'reports.initialReportsCall'
    },
    auth: {
      isRMUserGroup: true
    }
  },
})(ReportHome);
